import React, { useRef, useState } from "react";
import Button from "./Button";

const UploadButton = ({
  label = "Upload File",
  color = "black",
  accept = "*",
  onUpload = () => {},
  disabled = false,
  isAccessible = true,
  showUploadedFile = false,
  ...props
}) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const handleClick = () => {
    if (!disabled && isAccessible) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      setFileName(files[0].name);
      onUpload(files);
    }
    event.target.value = "";
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "fit-content",
        }}
      >
        <Button
          {...props}
          color={color}
          label={label}
          onClick={handleClick}
          disabled={disabled}
          isAccessible={isAccessible}
        />
        {showUploadedFile && fileName && (
          <div style={{ marginLeft: "10px" }}>{fileName}</div>
        )}
      </div>
      <input
        type="file"
        ref={fileInputRef}
        accept={accept}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
};

export default UploadButton;
